import ContentOverlay from 'components/ContentOverlay';
import { split, isEmpty, forEach } from 'lodash';
import React, { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import TaniumCredentialsForm from './TaniumCredentialsForm';
import TaniumMappingForm from './TaniumMappingForm';
import { DELIMITER } from './TaniumMappingForm'

const TaniumConfligListing = (props) => {
    const columns = useMemo(() => [{
        title: "Computer Group",
        dataIndex: "nodeName",
        width: 240,
        render: (nodeName) => {
            if (isEmpty(nodeName)) {
                return "All";
            }
            const nodeObj = {}
            
            const nodeNameArray = split(nodeName, ',')
            forEach(nodeNameArray, _nodeName => {
                let [companyName, node] = split(_nodeName, DELIMITER)
                if (node) {
                    node = split(node.replace(/;/g, ','), ',');
                    nodeObj[companyName] = node
                }
            })
            
            const renderName = nodeNameArray.map(item => {
                const companyName = split(item, DELIMITER)[0];
                return <p>{nodeObj[companyName] ? `${companyName} - [${nodeObj[companyName]}]` : companyName}</p>
            })
                 
            return <ContentOverlay content={renderName} minHeight={40} />
        }
    }], [])

    return (<GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={TaniumMappingForm}
        CredentialsForm={TaniumCredentialsForm}
        extraColumns={columns}
    />)
};

export default TaniumConfligListing;
